import { FaBell, FaBullhorn, FaDollarSign, FaWater } from "react-icons/fa";
import { useAuth } from "../context/AuthContext";
import { useEffect, useState } from "react";
import NotificationsList from "./NotificationsList";

const NotifcationBell = () => {
  const { notifications } = useAuth();

  // Check if there are any unread notifications

  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [hasUnreadNotifications, setHasUnreadNotifications] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
    setHasUnreadNotifications(false);
  };

  useEffect(() => {
    const hasUnread = notifications?.some((notif) => !notif.read_status);
    setHasUnreadNotifications(hasUnread);
  }, [notifications]);
  return (
    <>
      <div className="relative">
        <button onClick={toggleSidebar} className="p-2 rounded-full ">
          <svg
         className="h-6 w-6"
            viewBox="0 0 21 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          ><path
                d="M19.2562 12.5632L17.6336 6.72499C17.158 5.01465 16.1243 3.51236 14.6968 2.45693C13.2694 1.4015 11.5301 0.853494 9.75551 0.900022C7.98087 0.94655 6.27271 1.58494 4.90254 2.71372C3.53237 3.8425 2.57883 5.39689 2.19349 7.12981L0.937201 12.7792C0.798433 13.4035 0.801641 14.0509 0.946589 14.6738C1.09154 15.2966 1.37452 15.8789 1.77465 16.3778C2.17478 16.8766 2.68184 17.2792 3.25839 17.5558C3.83494 17.8325 4.46626 17.9761 5.10574 17.976H6.05714C6.25315 18.9414 6.77686 19.8092 7.53952 20.4326C8.30219 21.0559 9.2569 21.3965 10.2419 21.3965C11.2269 21.3965 12.1816 21.0559 12.9443 20.4326C13.707 19.8092 14.2307 18.9414 14.4267 17.976H15.1424C15.8007 17.9761 16.4501 17.8239 17.0398 17.5315C17.6296 17.239 18.1437 16.8141 18.5421 16.2901C18.9405 15.766 19.2123 15.1569 19.3364 14.5104C19.4604 13.8639 19.4333 13.1975 19.2571 12.5632H19.2562ZM10.2419 19.6841C9.71389 19.6819 9.19945 19.5167 8.76896 19.2109C8.33846 18.9052 8.01295 18.4739 7.83695 17.976H12.6469C12.4709 18.4739 12.1454 18.9052 11.7149 19.2109C11.2844 19.5167 10.7699 19.6819 10.2419 19.6841ZM17.1818 15.2559C16.9438 15.5717 16.6355 15.8275 16.2813 16.0032C15.9271 16.1789 15.5369 16.2695 15.1415 16.268H5.10574C4.7221 16.2679 4.34337 16.1817 3.9975 16.0157C3.65163 15.8497 3.34746 15.6081 3.10744 15.3088C2.86742 15.0095 2.69767 14.6602 2.61073 14.2865C2.52379 13.9128 2.52188 13.5244 2.60513 13.1499L3.86056 7.4996C4.16319 6.13845 4.91214 4.91752 5.98835 4.0309C7.06456 3.14428 8.40627 2.64285 9.80018 2.60634C11.1941 2.56982 12.5602 3.00031 13.6814 3.82936C14.8025 4.65842 15.6144 5.83846 15.9879 7.1819L17.6105 13.0201C17.7177 13.4004 17.7348 13.8006 17.6604 14.1887C17.586 14.5768 17.4221 14.9422 17.1818 15.2559Z"
                fill="#6C7072"
              />
           
          </svg>
        </button>
        {/* Notification dot */}
        {hasUnreadNotifications && (
          <span className="absolute top-0 right-0 w-2 h-2 bg-red-600 rounded-full"></span>
        )}
      </div>
      <NotificationsList
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
        notifications={notifications}
      />
    </>
  );
};
export default NotifcationBell;
